export class CommonFunction {
	static customSTMBRound(num: number): number {
		const decVal = parseFloat((num % 1).toFixed(2)); // Get 2 decimal point
		const decSubVal = parseFloat((num % 1).toFixed(2).substring(0, 3)); // Get 1 decimal point

		if (decVal >= parseFloat((decSubVal + 0.01).toFixed(2)) && decVal <= parseFloat((decSubVal + 0.02).toFixed(2))) {
			return Math.floor(num) + decSubVal;
		} else if (decVal >= parseFloat((decSubVal + 0.03).toFixed(2)) && decVal <= parseFloat((decSubVal + 0.05).toFixed(2))) {
			return Math.floor(num) + (decSubVal + 0.05);
		} else if (decVal >= parseFloat((decSubVal + 0.06).toFixed(2)) && decVal <= parseFloat((decSubVal + 0.07).toFixed(2))) {
			return Math.floor(num) + (decSubVal + 0.05);
		} else if (decVal >= parseFloat((decSubVal + 0.08).toFixed(2)) && decVal <= parseFloat((decSubVal + 0.09).toFixed(2))) {
			return Math.floor(num) + (decSubVal + 0.10);
		} else {
			return num;
		}
	}

	/**
   * [PSSR-3152] Incorrect DOBs
   *
   * Issue:
   * The Date is converted from the local machine's timezone to UTC+0 before it
   * is sent to the backend. The backend then converts it to Malaysia time (UTC+8).
   * If the machine timezone is ahead of +8 (e.g. Japan +9), the date goes back 1 day:
   * Pick 1 Sep 00:00 (+9) -> 31 Aug 15:00 UTC -> backend +8 -> 31 Aug 23:00
   *
   * Fix:
   * Always send the date picked on the calendar as UTC+0 midnight, whatever the
   * machine timezone is, e.g. "2026-09-01T00:00:00.000Z".
   *
   * Applied to:
   * 1. Customer Info DOB: backend converts to UTC+8, stored as 1 Sep 08:00
   * 2. Additional Driver DOB: backend stores the value as sent, stored as 1 Sep 00:00
   *
   * @param date the picked Date to convert, or null/undefined if not set
   * @returns a UTC-midnight ISO string, e.g. "2026-09-01T00:00:00.000Z", or null
   */
	static toCalendarDateUtc(date?: Date | null): string | null {
    if (date == null) return null;

    const d = new Date(date);

    const pad = (n: number) => String(n).padStart(2, "0");
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());

    return `${year}-${month}-${day}T00:00:00.000Z`;
  }
}
